import { PageParam } from '../types';

export const getPreviousPageParam = (firstPage: PageParam) => {
  if (firstPage.page == 1) return;
  return {
    page: firstPage.page - 1,
    pageSize: firstPage.pageSize,
  };
};

export const getNextPageParam = (lastPage: PageParam & { total: number | string }) => {
  const totalPages = Math.ceil(Number(lastPage.total) / lastPage.pageSize);
  if (lastPage.page >= totalPages) return;
  return {
    page: lastPage.page + 1,
    pageSize: lastPage.pageSize,
  };
};
